<template>
  <PopinBase
    :is-active="alert && !isClosed ? true : false"
    size="4xs"
    :is-closable="alert?.isClosable ?? true"
    is-outer-close
    @close="() => onAction(closeAction?.action)"
  >
    <template #body>
      <div class="p-4 font-medium space-y-1">
        <p class="font-bold text-lg">{{ alert?.title }}</p>
        <p class="font-medium" v-html="alert?.content"></p>
        <p class="bg-tiger-100 text-tiger-950 dark:bg-tiger-400/20 dark:text-tiger-50 p-3.5 rounded-xl !mt-3" v-if="alert?.warning">{{ alert.warning }}</p>

        <div class="flex items-center space-x-1.5 !mt-4">
          <ButtonBase
            :color="'white'"
            size="sm"
            :class="[ action.isMainAction ? '' : 'shrink-0' ]"
            :is-loading="isLoading"
            :is-full="action.isMainAction ? true : false"
            v-bind="action.button ?? {}"
            @click="() => onAction(action.action)"
            v-for="action in alert?.actions"
          >
            {{ action.text }}
          </ButtonBase>
        </div>
      </div>
    </template>
  </PopinBase>
</template>

<script lang="ts" setup>
import WindowStore from '@/store/window'

const windowStore = WindowStore()
const { alert } = storeToRefs(windowStore)

const isLoading = ref(false)
const isClosed = ref(false)

const closeAction = computed(() => {
  return (alert.value?.actions ?? []).find((action) => action.isCloseAction)
})

watch(alert, () => {
  if (alert.value) isClosed.value = false
})

const onAction = async (action?: () => void) => {
  isLoading.value = true
  
  if (action) await action()

  isClosed.value = true
  setTimeout(() => windowStore.setAlert(null), 300)

  isLoading.value = false
}
</script>